// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1fOWi","inputWrap":"styles_inputWrap__Fb7V7","input":"styles_input__1QFt4"};